module.exports = __webpack_public_path__ + "static/feedback-portal-large-9e4f20ddea8505bfcc2d08a10a18e34e.png";